module.exports = __webpack_public_path__ + "static/media/Logo_Black.67a5ec88.png";